import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { RouteNotFound } from '../../core';
import { Apps } from "../Apps";
import { RouteList } from './Routes';
import { BaseName } from "../../environment";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Apps />,
    errorElement: <RouteNotFound />,
    children: RouteList
  },
],{ basename: BaseName });


export const RouteProvider = () =>(<RouterProvider base router={router} fallbackElement={ <RouteNotFound /> }/> );
